module.exports = __webpack_public_path__ + "img/jo3.81fa871d.png";